import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  dashedContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px dashed #d9d9d9',
    justifyContent: 'center',
    padding: '10px',
    marginBottom: '24px',
    marginTop: 30,
  },
}));
